import { render } from "./ResourcesPage.vue?vue&type=template&id=7a1ca83e&scoped=true&ts=true"
import script from "./ResourcesPage.vue?vue&type=script&lang=ts"
export * from "./ResourcesPage.vue?vue&type=script&lang=ts"

import "./ResourcesPage.vue?vue&type=style&index=0&id=7a1ca83e&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1ca83e"]])

export default __exports__